<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jtKoa3/tc-custom/9781429903073.jpg?1730950365009" alt="This image is the cover for the book Hot Lights, Cold Steel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hot Lights, Cold Steel
      </h1>
      <p class="bookDescription body article font2">
        <b>“An orthopedic surgeon’s down-to-earth, fast-paced, and frequently funny memoir of his residency [told] with a born storyteller’s skill.” —<i>Kirkus Reviews</i></b><br/><br/>Michael Collins’ account of his four-year surgical residency at the famed Mayo Clinic traces his rise from an eager but clueless first-year resident navigating chaos and feelings of inadequacy to accomplished Chief Resident in his final year. With unparalleled humor, he recounts the disparity between people’s perceptions of a doctor’s glamorous life and the real thing: a succession of rundown cars towed to the junk yard, long weekends moonlighting at rural hospitals, a family that grows larger every year, and a laughable income. Collins’ good nature helps him over some of the rough spots—but cannot spare him the harsh realities and heart-wrenching decisions of a doctor’s life. A teenager’s leg is mangled by a tractor: risk the boy’s life to save his leg, or amputate immediately? A woman diagnosed with bone cancer injures her hip: should he recommend a painful operation even though she has only months to live? Unflinching and deeply engaging, <i>Hot Lights, Cold Steel</i> captures the author’s struggles to reconcile his idealism and desire to heal with the recognition of his own limitations and imperfections.<br/><br/>“Collins’ life as a surgical resident is heartbreaking one minute and triumphant the next. You’ll laugh and cry and cheer.” —Augusten Burroughs, <i>New York Times</i>–bestselling author of <i>Dry</i><br/><br/>“At once darkly humorous and truly compassionate. Not since <i>House of God</i> has there been such a ferociously funny look at the world of hospital medicine.” —Michael Palmer, <i>New York Times</i>–bestselling author of <i>The Last Surgeon</i><br/><br/>“I adore this book.” —Tess Gerritsen, <i>New York Times</i>–bestselling author of the Rizzoli &amp; Isles novels
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael J. Collins
      </h2>
      
      <p class="authorDescription body article"><P><B>Michael Collins</B> served as Chief Resident in Orthopedic Surgery at the Mayo Clinic. Currently he is an active partner in a busy surgical practice in Chicago where he lives with his wife Patti and their twelve children. <I>Hot Lights, Cold Steel</I> is his first book.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s griffin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07483d3a